import {useLayoutEffect} from 'react';

export const useResetWindowScroll = () => {
    useLayoutEffect(() => {
        window.requestAnimationFrame(() => {
            window.scrollTo(0, 0)
        });
    }, []);
};
